import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchFilms'
})

export class SearchFilmsPipe implements PipeTransform {

  transform(pipeData, pipeModifier): any {
    return pipeData.filter(eachItem => {
      return (
        eachItem['title'].toLowerCase().includes(pipeModifier.toLowerCase()) || (eachItem['content'] &&
        eachItem['content']['block']['settings']['excerpt'].toLowerCase().includes(pipeModifier.toLowerCase()))
      )
    });
  }

}